export default __webpack_public_path__ + "92b5826e235442a527fb15332e6dc845.png";